module.exports = __webpack_public_path__ + "img/backarrowgrey.e306062d.svg";